// ----------------------------------------------------------------------
// <copyright file="Izenda.TimezoneConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * TimezoneConstants
 * Abr: https://en.wikipedia.org/wiki/List_of_time_zone_abbreviations
 */

export default {
  TIMEZONE: [
    {
      label: '(UTC-12:00) International Date Line West',
      value: 'Dateline Standard Time',
      abr: ['BIT']
    },
    {
      label: '(UTC-11:00) Coordinated Universal Time-11',
      value: 'UTC-11',
      abr: ['NUT', 'SST']
    },
    {
      label: '(UTC-10:00) Hawaii',
      value: 'Hawaiian Standard Time',
      abr: ['CKT', 'HAST', 'TAHT']
    },
    {
      label: '(UTC-09:00) Alaska',
      value: 'Alaskan Standard Time',
      abr: ['HADT', 'GIT', 'GAMT', 'AKST']
    },
    {
      label: '(UTC-08:00) Baja California',
      value: 'Pacific Standard Time (Mexico)',
      abr: ['AKDT', 'CIST', 'PST']
    },
    { label: '(UTC-08:00) Pacific Time (US & Canada)', value: 'Pacific Standard Time' },
    {
      label: '(UTC-07:00) Arizona',
      value: 'US Mountain Standard Time',
      abr: ['MST', 'PDT']
    },
    { label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan', value: 'Mountain Standard Time (Mexico)' },
    { label: '(UTC-07:00) Mountain Time (US & Canada)', value: 'Mountain Standard Time' },
    {
      label: '(UTC-06:00) Central America',
      value: 'Central America Standard Time',
      abr: ['MDT', 'GALT', 'EAST', 'CST']
    },
    { label: '(UTC-06:00) Central Time (US & Canada)', value: 'Central Standard Time' },
    { label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey', value: 'Central Standard Time (Mexico)' },
    { label: '(UTC-06:00) Saskatchewan', value: 'Canada Central Standard Time' },
    {
      label: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
      value: 'SA Pacific Standard Time',
      abr: ['ACT', 'CDT', 'COT', 'CST', 'EASST', 'ECT', 'EST', 'PET']
    },
    { label: '(UTC-05:00) Chetumal', value: 'Eastern Standard Time (Mexico)' },
    { label: '(UTC-05:00) Eastern Time (US & Canada)', value: 'Eastern Standard Time' },
    { label: '(UTC-05:00) Indiana (East)', value: 'US Eastern Standard Time' },
    { label: '(UTC-04:30) Caracas', value: 'Venezuela Standard Time' },
    {
      label: '(UTC-04:00) Asuncion',
      value: 'Paraguay Standard Time',
      abr: ['AMT', 'AST', 'BOT', 'CDT', 'CLT', 'COST', 'ECT', 'EDT', 'FKT', 'GYT', 'PYT', 'VET']
    },
    { label: '(UTC-04:00) Atlantic Time (Canada)', value: 'Atlantic Standard Time' },
    { label: '(UTC-04:00) Cuiaba', value: 'Central Brazilian Standard Time' },
    { label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan', value: 'SA Western Standard Time' },
    {
      label: '(UTC-03:30) Newfoundland',
      value: 'Newfoundland Standard Time',
      abr: ['NST', 'NT']
    },
    {
      label: '(UTC-03:00) Brasilia',
      value: 'E. South America Standard Time',
      abr: ['ADT', 'AMST', 'ART', 'BRT', 'CLST', 'FKST', 'GFT', 'PMST', 'ROTT', 'SRT', 'UYT']
    },
    { label: '(UTC-03:00) Cayenne, Fortaleza', value: 'SA Eastern Standard Time' },
    { label: '(UTC-03:00) City of Buenos Aires', value: 'Argentina Standard Time' },
    { label: '(UTC-03:00) Greenland', value: 'Greenland Standard Time' },
    { label: '(UTC-03:00) Montevideo', value: 'Montevideo Standard Time' },
    { label: '(UTC-03:00) Salvador', value: 'Bahia Standard Time' },
    { label: '(UTC-03:00) Santiago', value: 'Pacific SA Standard Time' },
    {
      label: '(UTC-02:00) Coordinated Universal Time-02',
      value: 'UTC-02',
      abr: ['BRST', 'FNT', 'GST', 'PMDT', 'UYST']
    },
    { label: '(UTC-02:00) Mid-Atlantic - Old', value: 'Mid-Atlantic Standard Time' },
    {
      label: '(UTC-01:00) Azores',
      value: 'Azores Standard Time',
      abr: ['EGT', 'CVT', 'AZOT']
    },
    { label: '(UTC-01:00) Cabo Verde Is.', value: 'Cape Verde Standard Time' },
    {
      label: '(UTC) Casablanca',
      value: 'Morocco Standard Time',
      abr: ['AZOST', 'EGST', 'WET']
    },
    { label: '(UTC) Coordinated Universal Time', value: 'UTC' },
    {
      label: '(UTC) Dublin, Edinburgh, Lisbon, London',
      value: 'GMT Standard Time',
      abr: ['GMT']
    },
    { label: '(UTC) Monrovia, Reykjavik', value: 'Greenwich Standard Time' },
    {
      label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
      value: 'W. Europe Standard Time',
      abr: ['BST', 'CET', 'DFT', 'IST', 'MET', 'WAT', 'WEST']
    },
    { label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague', value: 'Central Europe Standard Time' },
    { label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', value: 'Romance Standard Time' },
    { label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb', value: 'Central European Standard Time' },
    { label: '(UTC+01:00) West Central Africa', value: 'W. Central Africa Standard Time' },
    { label: '(UTC+01:00) Windhoek', value: 'Namibia Standard Time' },
    {
      label: '(UTC+02:00) Amman',
      value: 'Jordan Standard Time',
      abr: ['CAT', 'CEST', 'EET', 'HAEC', 'IST', 'MEST', 'SAST', 'USZ1', 'WAST']
    },
    { label: '(UTC+02:00) Athens, Bucharest', value: 'GTB Standard Time' },
    { label: '(UTC+02:00) Beirut', value: 'Middle East Standard Time' },
    { label: '(UTC+02:00) Cairo', value: 'Egypt Standard Time' },
    { label: '(UTC+02:00) Damascus', value: 'Syria Standard Time' },
    { label: '(UTC+02:00) E. Europe', value: 'E. Europe Standard Time' },
    { label: '(UTC+02:00) Harare, Pretoria', value: 'South Africa Standard Time' },
    { label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', value: 'FLE Standard Time' },
    { label: '(UTC+02:00) Istanbul', value: 'Turkey Standard Time' },
    { label: '(UTC+02:00) Jerusalem', value: 'Israel Standard Time' },
    { label: '(UTC+02:00) Kaliningrad (RTZ 1)', value: 'Kaliningrad Standard Time' },
    { label: '(UTC+02:00) Tripoli', value: 'Libya Standard Time' },
    {
      label: '(UTC+03:00) Baghdad',
      value: 'Arabic Standard Time',
      abr: ['AST', 'EAT', 'EEST', 'FET', 'IDT', 'IOT', 'MSK', 'SYOT']
    },
    { label: '(UTC+03:00) Kuwait, Riyadh', value: 'Arab Standard Time' },
    { label: '(UTC+03:00) Minsk', value: 'Belarus Standard Time' },
    { label: '(UTC+03:00) Moscow, St. Petersburg, Volgograd (RTZ 2)', value: 'Russian Standard Time' },
    { label: '(UTC+03:00) Nairobi', value: 'E. Africa Standard Time' },
    {
      label: '(UTC+03:30) Tehran',
      value: 'Iran Standard Time',
      abr: ['IRST']
    },
    {
      label: '(UTC+04:00) Abu Dhabi, Muscat',
      value: 'Arabian Standard Time',
      abr: ['AMT', 'AZT', 'GET', 'GST', 'MUT', 'RET', 'SAMT', 'SCT', 'VOLT']
    },
    { label: '(UTC+04:00) Baku', value: 'Azerbaijan Standard Time' },
    { label: '(UTC+04:00) Izhevsk, Samara (RTZ 3)', value: 'Russia Time Zone 3' },
    { label: '(UTC+04:00) Port Louis', value: 'Mauritius Standard Time' },
    { label: '(UTC+04:00) Tbilisi', value: 'Georgian Standard Time' },
    { label: '(UTC+04:00) Yerevan', value: 'Caucasus Standard Time' },
    {
      label: '(UTC+04:30) Kabul',
      value: 'Afghanistan Standard Time',
      abr: ['AFT', 'IRDT']
    },
    {
      label: '(UTC+05:00) Ashgabat, Tashkent',
      value: 'West Asia Standard Time',
      abr: ['HMT', 'MAWT', 'MVT', 'ORAT', 'PKT', 'TFT', 'TJT', 'TMT', 'UZT', 'YEKT']
    },
    { label: '(UTC+05:00) Ekaterinburg (RTZ 4)', value: 'Ekaterinburg Standard Time' },
    { label: '(UTC+05:00) Islamabad, Karachi', value: 'Pakistan Standard Time' },
    {
      label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
      value: 'India Standard Time',
      abr: ['IST', 'SLST']
    },
    { label: '(UTC+05:30) Sri Jayawardenepura', value: 'Sri Lanka Standard Time' },
    {
      label: '(UTC+05:45) Kathmandu',
      value: 'Nepal Standard Time',
      abr: ['NPT']
    },
    {
      label: '(UTC+06:00) Astana',
      value: 'Central Asia Standard Time',
      abr: ['ACT', 'BIOT', 'BST', 'BTT', 'KGT', 'OMST', 'VOST']
    },
    { label: '(UTC+06:00) Dhaka', value: 'Bangladesh Standard Time' },
    { label: '(UTC+06:00) Novosibirsk (RTZ 5)', value: 'N. Central Asia Standard Time' },
    {
      label: '(UTC+06:30) Yangon (Rangoon)',
      value: 'Myanmar Standard Time',
      abr: ['CCT', 'MMT']
    },
    {
      label: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
      value: 'SE Asia Standard Time',
      abr: ['CXT', 'DAVT', 'HOVT', 'ICT', 'KRAT', 'THA', 'WIT']
    },
    { label: '(UTC+07:00) Krasnoyarsk (RTZ 6)', value: 'North Asia Standard Time' },
    {
      label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
      value: 'China Standard Time',
      abr: ['AWST', 'BDT', 'CHOT', 'CIT', 'CST', 'CT', 'HKT', 'HOVST', 'IRKT', 'PST', 'WST']
    },
    { label: '(UTC+08:00) Irkutsk (RTZ 7)', value: 'North Asia East Standard Time' },
    {
      label: '(UTC+08:00) Kuala Lumpur, Singapore',
      value: 'Singapore Standard Time',
      abr: ['MST', 'MYT', 'SGT', 'SST']
    },
    { label: '(UTC+08:00) Perth', value: 'W. Australia Standard Time' },
    { label: '(UTC+08:00) Taipei', value: 'Taipei Standard Time' },
    {
      label: '(UTC+08:00) Ulaanbaatar',
      value: 'Ulaanbaatar Standard Time',
      abr: ['ULAT']
    },
    { label: '(UTC+08:30) Pyongyang', value: 'North Korea Standard Time' },
    {
      label: '(UTC+09:00) Osaka, Sapporo, Tokyo',
      value: 'Tokyo Standard Time',
      abr: ['CHOST', 'EIT', 'JST', 'KST', 'TLT', 'ULAST', 'YAKT']
    },
    { label: '(UTC+09:00) Seoul', value: 'Korea Standard Time' },
    { label: '(UTC+09:00) Yakutsk (RTZ 8)', value: 'Yakutsk Standard Time' },
    {
      label: '(UTC+09:30) Adelaide',
      value: 'Cen. Australia Standard Time',
      abr: ['ACST', 'ACST']
    },
    { label: '(UTC+09:30) Darwin', value: 'AUS Central Standard Time' },
    {
      label: '(UTC+10:00) Brisbane',
      value: 'E. Australia Standard Time',
      abr: ['CHST', 'CHUT', 'DDUT', 'PGT', 'VLAT']
    },
    {
      label: '(UTC+10:00) Canberra, Melbourne, Sydney',
      value: 'AUS Eastern Standard Time',
      abr: ['AEST']
    },
    { label: '(UTC+10:00) Guam, Port Moresby', value: 'West Pacific Standard Time' },
    { label: '(UTC+10:00) Hobart', value: 'Tasmania Standard Time' },
    { label: '(UTC+10:00) Magadan', value: 'Magadan Standard Time' },
    { label: '(UTC+10:00) Vladivostok, Magadan (RTZ 9)', value: 'Vladivostok Standard Time' },
    {
      label: '(UTC+11:00) Chokurdakh (RTZ 10)',
      value: 'Russia Time Zone 10',
      abr: ['AEDT', 'BST', 'AEDT', 'KOST', 'LHST', 'MIST', 'NCT', 'NFT', 'PONT', 'SAKT', 'SBT', 'SRET', 'VUT']
    },
    { label: '(UTC+11:00) Solomon Is., New Caledonia', value: 'Central Pacific Standard Time' },
    {
      label: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky (RTZ 11)',
      value: 'Russia Time Zone 11',
      abr: ['GILT', 'MAGT', 'MHT', 'NZST', 'PETT', 'TVT', 'WAKT']
    },
    { label: '(UTC+12:00) Auckland, Wellington', value: 'New Zealand Standard Time' },
    { label: '(UTC+12:00) Coordinated Universal Time+12', value: 'UTC+12' },
    {
      label: '(UTC+12:00) Fiji',
      value: 'Fiji Standard Time',
      abr: ['FJT']
    },
    { label: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old', value: 'Kamchatka Standard Time' },
    {
      label: "(UTC+13:00) Nuku'alofa",
      value: 'Tonga Standard Time',
      abr: ['NZDT', 'PHOT', 'TKT', 'TOT']
    },
    { label: '(UTC+13:00) Samoa', value: 'Samoa Standard Time' },
    {
      label: '(UTC+14:00) Kiritimati Island',
      value: 'Line Islands Standard Time',
      abr: ['LINT']
    }
  ]
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.TimezoneConstants.js